import { render, staticRenderFns } from "./promotionTable.vue?vue&type=template&id=1847f830&scoped=true"
import script from "./promotionTable.vue?vue&type=script&lang=js"
export * from "./promotionTable.vue?vue&type=script&lang=js"
import style0 from "./promotionTable.vue?vue&type=style&index=0&id=1847f830&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1847f830",
  null
  
)

export default component.exports